import { computed } from 'nanostores';
import { persistentAtom } from '@nanostores/persistent';

type TFeedback = Record<string, boolean>;

const $feedback = persistentAtom<TFeedback>('klv-hc-feedback', {}, {
  encode: JSON.stringify,
  decode: JSON.parse,
});
  
export const getFeedback = (articleId: string) =>
  computed($feedback, (feedback: TFeedback) => {
    return feedback[articleId] ?? false;
  });

export const addFeedback = (articleId: string) => {
  $feedback.set({
    ...$feedback.get(),
    [articleId]: true,
  });
};
